letterAdjust.scale = 0.8;
// Colors are in order like this...  home: [ inside, outline, outline2, outline3 ]
var font = {
    "0": "M0 98v869l96 98h468l98 -98v-869l-98 -98h-468zM176 183l5 -6h299l4 6l-4 704h-299l-5 -6v-698z",
    "1": "M0 0v177h58v676h-58v88l110 124h123v-888h59v-177h-292z",
    "2": "M0 0v306l483 523v52l-4 6h-296l-7 -6v-70h-176v156l96 98h467l99 -98v-208l-486 -524v-58h486v-177h-662z",
    "3": "M0 98v156h177v-71l6 -6h296l5 6v255l-5 5h-211v177h211l5 7v254l-5 6h-296l-6 -6v-70h-177v156l98 98h466l98 -98v-379l-59 -56l59 -57v-377l-98 -98h-466z",
    "4": "M0 448l304 617h282v-637h87v-178h-87v-250h-177v250h-356zM188 430l1 -2h220v451z",
    "5": "M0 98v156h177v-71l6 -6h296l5 6v255l-5 5h-381l-98 97v525h662v-178h-485v-261l6 -6h381l98 -97v-425l-98 -98h-466z",
    "6": "M0 98v869l96 98h468l98 -98v-158h-178v72l-4 6h-299l-5 -6v-261h388l98 -97v-425l-98 -98h-468zM176 183l5 -6h299l4 6v255l-4 5h-304v-260z",
    "7": "M0 809v256h560l85 -85l-207 -980h-179l186 887h-268v-78h-177z",
    "8": "M0 98v377l58 57l-58 56v379l98 98h466l98 -98v-379l-56 -56l56 -57v-377l-98 -98h-466zM177 183l4 -6h299l4 6v255l-4 5h-299l-4 -5v-255zM177 626l4 -6h299l4 6v255l-4 6h-299l-4 -6v-255z",
    "9": "M0 98v156h177v-71l7 -6h296l6 6v260h-390l-96 97v428l96 97h468l98 -97v-870l-98 -98h-468zM177 627l7 -6h302v260l-6 7h-296l-7 -7v-254z",
    "A": "M0 0l128 1065h263l128 -1065h-134l-26 193h-199l-25 -193h-135zM176 328h168l-72 603h-24z",
    "B": "M0 0v1065h417l105 -111v-339l-88 -81l88 -84v-342l-105 -108h-417zM135 135h252v330h-252v-330zM135 602h252v329h-252v-329z",
    "C": "M0 108v846l105 111h309l108 -111v-198h-135v175h-252v-796h252v174h135v-201l-108 -108h-309z",
    "D": "M0 0v1065h417l108 -111v-846l-108 -108h-417zM135 135h254v796h-254v-796z",
    "E": "M0 0v1065h525v-134h-390v-329h308v-137h-308v-330h390v-135h-525z",
    "F": "M0 0v1065h525v-134h-388v-329h306v-137h-306v-465h-137z",
    "G": "M0 108v846l105 111h309l108 -111v-198h-135v175h-252v-796h252v174h-113v137h248v-338l-108 -108h-309z",
    "H": "M0 0v1065h135v-463h252v463h135v-1065h-135v465h-252v-465h-135z",
    "I": "M0 0h137v1065h-137v-1065z",
    "J": "M0 108v201h135v-174h254v930h136v-957l-108 -108h-309z",
    "K": "M0 0v1065h135v-399l254 399h160l-214 -341l214 -724h-143l-169 573l-102 -159v-414h-135z",
    "L": "M0 0v1065h135v-930h387v-135h-522z",
    "M": "M0 0v1065h135l127 -429l127 429h136v-1065h-136v587l-127 -427l-125 427v-587h-137z",
    "N": "M0 0v1065h187l203 -741v741h135v-1065h-187l-203 739v-739h-135z",
    "O": "M0 108v846l108 111h328l86 -111v-846l-105 -108h-309zM135 135h252v796h-252v-796z",
    "P": "M0 0v1065h436l86 -111v-403l-105 -108h-282v-443h-135zM135 578l252 2v351h-252v-353z",
    "Q": "M0 108v846l108 111h310l108 -111v-846l-102 -104l60 -117h-132l-56 113h-188zM136 135h254v796h-254v-796z",
    "R": "M0 0v1065h436l86 -111v-381l-105 -106l80 -467h-138l-79 465h-145v-465h-135zM135 601l252 1v329h-252v-330z",
    "S": "M0 108v201h135v-174h252v330h-282l-105 108v381l105 111h329l88 -111v-198h-135v175h-252v-329h299l88 -109v-385l-108 -108h-309z",
    "T": "M0 931v134h525v-134h-195v-931h-137v931h-193z",
    "U": "M0 108v957h135v-930h252v930h135v-957l-105 -108h-309z",
    "V": "M0 1065h135l113 -930h24l113 930h134l-128 -1065h-263z",
    "W": "M0 1065h137l76 -642l131 502l134 -502l76 642h134l-125 -1065h-115l-104 391l-102 -391h-114z",
    "X": "M0 0l259 534l-259 531h151l184 -377l184 377h152l-260 -531l260 -534h-152l-184 380l-184 -380h-151z",
    "Y": "M0 1065h146l155 -388l160 388h143l-234 -577v-488h-135v488z",
    "Z": "M0 135l370 796h-352v134h434l67 -134l-370 -796h350v-135h-433z"
};
var font_size = 27,
    tracking = 3,
    panel_Hor_Adjustment = 2,
    font_Top_Adjustment = -22.5,
    middleSpreadAdjustment = {
        left: 1,
        right: 1
    },
    small_Caps_Adjustment = {
        vertical: -215,
        horizontal: 0,
        scale_width: 0, // effects period
        scale_height: 0, // effects period
    },
    colors = {
        characters: {
            home: [
                "#FFFFFF", // white
                "#231F20", // black
            ],
            away: [
                "#E31837", // red
                "#231F20", // black
            ]
        },
        numbers: {
            home: [
                "#FFFFFF", // white
                "#231F20", // black
            ],
            away: [
                "#E31837", // red
                "#231F20", // black
            ]
        }
    },
    outlines = {
        characters: {
            width: 0
        },
        numbers: {
            width: 3
        }
    },
    special_Character_Adjustments = {
        period: {
            vertical: 7.5, // this moves it up from the bottom
            horizontal: 3,
            scale_width: 12.5,
            scale_height: 12.5,
        },
        hyphen: {
            vertical: -6,
            horizontal: -5.5,
            scale_width: 0,
            scale_height: -3,
        },
        apostrophe: {
            vertical: 0.25, // this is backwards
            horizontal: -1,
            scale_width: 0,
            scale_height: 0,
        }
    },
    number_Adjustments = {
        top: 18,
        left: -4,
        width: 100,
        height: 90,
        middle_Space: 5,
        oneOffset: 7
    };
